export function ourMissionListSliderOnMobile() {
    const $window = $(window);
    const parent = $(".our-mission-list.slider-on-mobile");

    function mobileSlider() {
        parent.each(function () {
            let $this = $(this);
            if ($window.innerWidth() >= 1024) {
                if ($this.hasClass("slick-initialized")) {
                    $this.slick('refresh');
                    $this.slick('unslick');
                }
            } else {
                if (!$this.hasClass("slick-initialized")) {
                    $this.slick({
                        dots: true,
                        arrows: false,
                        infinite: false,
                        speed: 700,
                        cssEase: 'ease',
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        mobileFirst: true,
                        responsive: [
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                }
                            }
                        ]
                    })
                }
            }
        });
    }

    $window.on("load resize", function () {
        mobileSlider();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/ourMissionListSliderOnMobile.js